var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip"},[_c('span',[_vm._v(_vm._s(_vm.params.value != null
      ? this.SetTimeByZone(_vm.params.value, _vm.Session_Event_TZ)
      : ""))])])
}
var staticRenderFns = []

export { render, staticRenderFns }